const env = process.env.REACT_APP_ENV;

let basename = '';

if (env === 'uat' || env === 'test' || env === 'production') {
    basename = '/wechat/#'
}

export const BASE_NAME = basename;